import { createJobApplyUrl } from "@/helpers/jobs";
import { Button } from "@monsterindia/global-ui-components";

type SprButtonsProps = {
  handleClick?: () => void;
  isDisabled: boolean;
  isLoading: boolean;
};

const SprButtons: React.FC<SprButtonsProps> = ({
  handleClick,
  isDisabled,
  isLoading,
}) => {
  const redirectToLogin = () => {
    const searchParams = new URLSearchParams(window.location.search);
    let detailPageUrl = createJobApplyUrl(searchParams);
    if (searchParams.toString()) {
      detailPageUrl += `&${searchParams.toString()}`;
    }
    window.location.href =
      "/rio/login/seeker?return_url=" + encodeURIComponent(detailPageUrl);
  };

  return (
    <div className="shadow-top flex w-full flex-col gap-4 p-6">
      <Button
        type="submit"
        modifier="primary"
        label="Continue"
        size="lg"
        className="w-full"
        onClick={handleClick}
        disabled={isDisabled || isLoading}
      />
      <p className="text-content-placeholder relative border-b text-center text-xs">
        <span className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 bg-white px-2">
          Already registered ?
        </span>
      </p>
      <Button
        modifier="secondary"
        label="Login & apply"
        size="lg"
        className="w-full"
        onClick={redirectToLogin}
      />
    </div>
  );
};

export default SprButtons;
